import { ProjectActivityDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectActivity = createAction(
  '[ProjectActivity] Load ProjectActivity'
);

export const loadProjectActivitySuccess = createAction(
  '[ProjectActivity] Load ProjectActivity Success',
  props<{ projectActivity: ProjectActivityDto[] }>()
);

export const loadProjectActivityFailure = createAction(
  '[ProjectActivity] Load ProjectActivity Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectActivity = createAction(
  '[ProjectActivity] Add ProjectActivity',
  props<{ newProjectActivity: ProjectActivityDto[] }>()
);

export const addProjectActivitySuccess = createAction(
  '[ProjectActivity] Add ProjectActivity Success',
  props<{ newProjectActivity: ProjectActivityDto[] }>()
);

export const addProjectActivityFailure = createAction(
  '[ProjectActivity] Add ProjectActivity Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectActivityRecord = createAction(
  '[ProjectActivity] Search  ProjectActivity Record',
  props<{ query: string }>()
);

/**
 * Update ProjectActivity Collection Actions
 */
export const updateProjectActivity = createAction(
  '[ProjectActivity] Update ProjectActivity',
  props<{ updateProjectActivity: ProjectActivityDto[] }>()
);

export const updateProjectActivitySuccess = createAction(
  '[ProjectActivity] Update ProjectActivity Success',
  props<{ updateProjectActivity: ProjectActivityDto[] }>()
);

export const updateProjectActivityFailure = createAction(
  '[ProjectActivity] Update ProjectActivity Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectActivity Collection Actions
 */
export const removeProjectActivity = createAction(
  '[ProjectActivity] Remove ProjectActivity',
  props<{ ids: string[] }>()
);

export const removeProjectActivitySuccess = createAction(
  '[ProjectActivity] Remove ProjectActivity Success',
  props<{ ids: string[] }>()
);

export const removeProjectActivityFailure = createAction(
  '[ProjectActivity] Remove ProjectActivity Failure',
  props<{ error: any }>()
);
